<template>
  <div class="branding-filter__content">
    <div class="branding-filter__cell start">
      <div class="branding-filter__cell half">
        <text-input
          v-model="payload.labelQuery"
          class="branding-filter__input"
          :title-label="$t('query')"
          :has-bar="false"
          @keyup.enter="submit"
        />
      </div>

      <div
        v-for="(elem, i) in dropDowns"
        :key="i"
        class="branding-filter__cell half"
      >
        <template v-if="elem.items">
          <multi-select
            v-model="payload[elem.id]"
            class="branding-filter__input"
            display-key="text"
            :options="elem.items"
            :title="elem.title"
            @keyup.enter="submit"
          />
        </template>
      </div>
    </div>
    <div class="branding-filter__cell end">
      <div class="branding-filter__cell">
        <radio-group
          v-if="radioData.items"
          v-model="payload[radioData.id]"
          :class="{ removeMargin: !isMobile }"
          :items="radioData.items"
          required
          :horizontal="isMobile"
          @keyup.enter="submit"
        />
        <div class="branding-filter__button">
          <sanitas-button
            class="removeMargin"
            primary
            full-width-in-xs
            @click="submit"
          >
            {{ $t('button-submit') }}
          </sanitas-button>
        </div>
      </div>
      <div class="branding-filter__cell">
        <span class="resetLabel" @click="reset">{{ $t('reset') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { useI36n } from '@jota-one/i36n/src/index.vue2'

import MultiSelect from './MultiSelect'

export default {
  name: 'SanitasBrandingFilterFull',
  components: {
    MultiSelect,
    RadioGroup: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/RadioGroup'
      )
    },
    SanitasButton: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/SanitasButton'
      )
    },
    TextInput: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/TextInput'
      )
    },
  },

  props: {
    dropDowns: {
      type: Array,
      default: () => [],
    },
    radioData: {
      type: Object,
      default: () => {},
    },
    defaultValues: {
      type: Object,
      default: () => {},
    },
  },

  setup() {
    const { $label } = useI36n()

    return {
      $t: $label,
    }
  },

  data: () => ({
    payload: {},
  }),
  computed: {
    isMobile() {
      return !this.$mq['md!']
    },
  },
  watch: {
    defaultValues: {
      handler(values) {
        this.payload = values
      },
      immediate: true,
    },
  },
  methods: {
    submit() {
      const params = Object.keys(this.payload)
        .map(key => {
          if (Array.isArray(this.payload[key])) {
            return this.payload[key]
              .map(el => key + '=' + encodeURIComponent(el))
              .join('&')
          }
          return key + '=' + encodeURIComponent(this.payload[key])
        })
        .join('&')
      if (history.pushState) {
        window.location.hash = params
      }
      if (this.inViewport('mobile')) {
        window.scroll({
          top: 480,
          left: 0,
          behavior: 'smooth',
        })
      }
    },
    reset() {
      this.payload = {}
      if (history.pushState) {
        window.location.hash = '_'
      }
    },
  },
}
</script>

<style lang="postcss">
.branding-filter {
  &__cell {
    .resetLabel {
      font-size: 16px;
      font-weight: normal;
      font-style: normal;
      line-height: 1.25;
      color: var(--c-primary-color-3);
      text-decoration: underline;
      cursor: pointer;
    }

    &.half {
      margin-bottom: 25px;
    }

    &.start {
      flex-wrap: wrap;
      justify-content: normal;
      padding: 0;
    }

    &.end {
      width: auto;
      padding: 0;
      align-items: start;
      flex-wrap: wrap;
      margin-top: -5px;
    }
  }
}

@media (max-width: 768px) {
  .branding-filter {
    &__cell {
      &.half {
        margin-bottom: 0;
      }

      &.end {
        margin-top: 0;
      }
    }
  }
}
</style>
